import { useState } from "react";
import { FRONTEND_URL, IMAGE_URL } from "../../config/axios"
import usePermission from "../../config/permissions";
import UserDefaultLogo, { getRandomColor } from "../UserDetails/UserDefaultLogo";
import { UpdateEmployeeData } from "./components/AddNewEmployeeModel";
import { CustomImageModal } from "../CustomFunctions";
import { Tripledot, TripledotLarge, UpdatePencil, Eye, UpdatePencilBox, BlueEye } from "../AllSvg";
import { useNavigate, Link } from "react-router-dom";

const EmployeeDetailCard = ({ getAllEmployee, filteredEmployee, Viewdetails, SUPER_ADMIN, SubCompany }) => {
    const role = sessionStorage.getItem('role')

    const [activeOptionEmpCode, setActiveOptionEmpCode] = useState(null);

    const toggleDisplayOption = (empCode) => {
        if (activeOptionEmpCode === empCode) {
            setActiveOptionEmpCode(null);
        } else {
            setActiveOptionEmpCode(empCode);
        }
    };

    return (
        <>
            <div className='employee-cards'>

                {filteredEmployee.sort((a, b) => a.emp_code - b.emp_code).map((e, index) => {
                    return (
                        <div className='employee-card'>
                            <div className='employee-card-a'>
                                <div className='employee-card-image'>
                                    <div className='employee-card-image-background'>
                                        <CustomImageModal customStyle>
                                            {e.profilepic ? (
                                                <img
                                                    src={`${IMAGE_URL}${e.profilepic}`}
                                                    alt="card-pic"
                                                    className="employee-card-imageee"
                                                />
                                            ) : (
                                                <UserDefaultLogo
                                                    user={{ name: e.name, profilepic: e.profilepic }}
                                                    customStyleforParent={'profile-container'}
                                                    customStyleforChild={'square-profile'}
                                                />
                                            )}
                                        </CustomImageModal>
                                    </div>
                                    <div className='employee-card-icons'>
                                        <div className='employee-card-name font-weight500   font-size-subheading'>{e.name}</div>
                                        <div className='employee-card-designation font-weight400   font-size-subheading'>{e.designation_name}</div>
                                        <div className="employee-card-name font-weight500   font-size-subheading">Emp Code: {e.emp_code}</div>
                                    </div>
                                </div>

                                <div className="relative" style={{ alignItems: 'flex-start' }}>
                                    <div className="flex-row justify-evenly align-center gap-1 ">
                                        <div
                                            className="badge-container"
                                            style={{ borderColor: getRandomColor(e.role).dark, backgroundColor: getRandomColor(e.role).light }}
                                        >
                                            {e.role}
                                        </div>
                                        <button
                                            className='employee-edit'
                                            onClick={() => toggleDisplayOption(e.emp_code)}
                                        >
                                            <Tripledot />
                                        </button>
                                    </div>
                                    {activeOptionEmpCode === e.emp_code && (
                                        <div className="modal-tripledot-wfm modal-profile-modal" style={{ zIndex: '1' }}>
                                            <div className="p-2 rounded-lg shadow-lg bg-white border border-gray-200">
                                                <div className="flex items-center gap-1 flex-column">

                                                    <div
                                                        className="flex flex-column items-center gap-1 rounded-md  cursor-pointer transition"
                                                    >
                                                        {role === 'HR' || role === 'Admin' ?

                                                            <>
                                                                <span className="modal-tripledot-flex hover:bg-gray-100">
                                                                    <UpdateEmployeeData
                                                                        i={e}
                                                                        SubCompany={SubCompany}
                                                                        getAllEmployee={getAllEmployee}
                                                                        SUPER_ADMIN={SUPER_ADMIN}
                                                                        btn_title={'Edit Company Details'}
                                                                    />
                                                                </span>

                                                                <Link
                                                                    to={`${FRONTEND_URL}/personaldetailss/${e.user_detail}/?company_id=${sessionStorage.getItem("company_id") || "null"}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="modal-tripledot-flex hover:bg-gray-100 w-full"
                                                                    style={{ color: 'black' }}
                                                                    title="Edit Profile Details"
                                                                >
                                                                    <span style={{ marginRight: '10px' }}>
                                                                        <div className="employee-detail-edit-svg">
                                                                            <UpdatePencilBox color={'black'} />
                                                                        </div>
                                                                    </span>
                                                                    Edit Profile Details
                                                                </Link>

                                                                <span className="modal-tripledot-flex hover:bg-gray-100 w-full" onClick={() => Viewdetails(e.emp_code, e.user_detail)} >
                                                                    <BlueEye />  <span style={{ marginLeft: '10px' }}>View Profile</span>
                                                                </span>
                                                            </>
                                                            : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='employee-card-b'>
                                <div className='employee-card-b-flex'>
                                    <div className="cart-subdiv-flex" ><span className='employee-card-b-heading  font-weight400  font-size-label'>Department  :  </span><span className='employee-card-b-text  font-weight400 ing font-size-label'>{e.department_name}</span></div>
                                    <div className="cart-subdiv-flex" ><span className='employee-card-b-heading  font-weight400  font-size-label'>Email  :  </span><span className='employee-card-b-text  font-weight400 ing font-size-label'>{e.user_detail}</span></div>

                                </div>
                                <div className='employee-card-b-flex'>
                                    <div className="cart-subdiv-flex" ><span className='employee-card-b-heading  font-weight400  font-size-label'>Location  :  </span><span className='employee-card-b-text  font-weight400 ing font-size-label'>{e.location_name}</span></div>
                                    <div className="cart-subdiv-flex" ><span className='employee-card-b-heading  font-weight400  font-size-label'>Mobile No :  </span><span className='employee-card-b-text  font-weight400 ing font-size-label'>{e.mobile_number}</span></div>
                                </div>

                            </div>


                        </div >
                    )
                })}
            </div >
        </>
    )
}
export default EmployeeDetailCard